import { Persistence } from '../../persistence/Persistence';
import { FlowStepRuleFunctionVariadic } from '../flow-engine';

export const rule: FlowStepRuleFunctionVariadic = async function rule(_apiContext, flowOptions) {
  const { currentPartnerRegion, user, currentPartner } = flowOptions;

  if (currentPartner === 'amazon-prime') {
    return true;
  }

  if (currentPartnerRegion && !['au', 'us', 'uk'].includes(currentPartnerRegion)) {
    return false;
  }

  const loyaltyId = user?.loyaltyInfo?.loyaltyId || Persistence.getLoyaltyId();
  if (user?.phoneNumberVerified && user?.phone && !loyaltyId) {
    return true;
  }

  return false;
};
